import type { StatusPresentation, Tone } from '../lib/orderStatus';

/**
 * A status pill.
 *
 * Colour follows the meaning of the state, never the other way round: a failure is not
 * softened to neutral because red looks alarming, and a pending state is not shown as
 * positive because it reads better.
 */

const TONE_STYLES: Record<Tone, { background: string; color: string; border: string }> = {
  neutral: {
    background: 'var(--mm-surface-subtle)',
    color: 'var(--mm-text-muted)',
    border: 'var(--mm-border)',
  },
  pending: {
    background: 'var(--mm-warning-soft)',
    color: 'var(--mm-warning)',
    border: 'var(--mm-warning-border)',
  },
  positive: {
    background: 'var(--mm-success-soft)',
    color: 'var(--mm-success)',
    border: 'var(--mm-success-soft)',
  },
  negative: {
    background: 'var(--mm-danger-soft)',
    color: 'var(--mm-danger)',
    border: 'var(--mm-danger-soft)',
  },
};

export default function StatusBadge({
  status,
  testId,
}: {
  status: StatusPresentation;
  testId?: string;
}) {
  const tone = TONE_STYLES[status.tone];

  return (
    <span
      data-testid={testId}
      data-tone={status.tone}
      className="inline-flex items-center rounded-full px-3 py-1 text-sm font-medium"
      style={{ background: tone.background, color: tone.color, border: `1px solid ${tone.border}` }}
    >
      {status.label}
    </span>
  );
}
